import { render, staticRenderFns } from "./zh_yjzpfd.vue?vue&type=template&id=13f8dce2&scoped=true&"
import script from "./zh_yjzpfd.vue?vue&type=script&lang=js&"
export * from "./zh_yjzpfd.vue?vue&type=script&lang=js&"
import style0 from "./zh_yjzpfd.vue?vue&type=style&index=0&id=13f8dce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8dce2",
  null
  
)

export default component.exports